// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.msitem[data-v-07176fde] {\n}\n.msitem--selected[data-v-07176fde] {\n}\n.msitem[data-v-07176fde]:hover {\n  background: rgba(230, 230, 230, 1);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
